<template>
  <div class="c-tabbar">
    <div class="item" @click.stop="$router.push('/home')">
      <div class="logo" :style="{backgroundImage: `url(${getTheme($route.path === '/home'? 'home:c-tabbar:icon-home-active' : 'home:c-tabbar:icon-home')})`}"></div>
      <p :class="{light: $route.path === '/home'}" :style="_getActiveStyle('/home')">{{$t('Home')}}</p>
    </div>
    <div class="item" v-if="hasPower('单位管理')" @click.stop="$router.push('/management')">
      <div class="logo" :style="{backgroundImage: `url(${getTheme($route.path === '/management' ? 'home:c-tabbar:icon-management-active' : 'home:c-tabbar:icon-management')})`}">
      </div>
      <p :class="{light: $route.path === '/management'}" :style="_getActiveStyle('/management')">{{$t('Manage')}}</p>
    </div>
    <div class="item" v-if="hasPower('行程')" @click.stop="_goTripList">
      <div class="logo" :style="{backgroundImage: `url(${getTheme($route.path === '/trip/list' ? 'home:c-tabbar:icon-trip-active' : 'home:c-tabbar:icon-trip')})`}"></div>
      <p :class="{light: $route.path === '/trip/list'}" :style="_getActiveStyle('/trip/list')">{{$t('Trip')}}</p>
    </div>
    <div class="item" @click.stop="$router.push('/message/center')">
      <div class="logo" :style="{backgroundImage: `url(${getTheme($route.path === '/message/center' ? 'home:c-tabbar:icon-message-active' : 'home:c-tabbar:icon-message')}`}">
        <div class="badge" v-if="noticeDetails && noticeDetails.TotalCount && noticeDetails.TotalCount > 0">{{noticeDetails.TotalCount > 99 ? '99+' : noticeDetails.TotalCount}}</div>
      </div>
      <p :class="{light: $route.path === '/message/center'}" :style="_getActiveStyle('/message/center')">{{$t('Message')}}</p>
    </div>
    <div class="item" @click.stop="$router.push('/personal/center')">
      <div class="logo" :style="{backgroundImage: `url(${getTheme($route.path === '/personal/center' ? 'home:c-tabbar:icon-personal-center-active' : 'home:c-tabbar:icon-personal-center')})`}"></div>
      <p :class="{light: $route.path === '/personal/center'}" :style="_getActiveStyle('/personal/center')">{{$t('Account')}}</p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import {mapState} from 'vuex';
import hasPower from "@/common/utility/hasPower";

export default {
  computed: {
    ...mapState([
      'UserManageInfo',
      'noticeDetails'
    ]),
    UnHandleVettingCount() {
      let UnHandleVettingCount = this.UserManageInfo && this.UserManageInfo.MeProcessVettingCountInfo &&
        this.UserManageInfo.MeProcessVettingCountInfo.UnHandleVettingCount ? this.UserManageInfo.MeProcessVettingCountInfo.UnHandleVettingCount : 0
      return UnHandleVettingCount
    }
  },
  methods: {
    hasPower,
    _getActiveStyle(path, key) {
      if (this.$route.path === path) {
        return {
          color: this.getTheme('home:c-tabbar:active-color')
        }
      }
      return {}
    },

    /** 跳转行程 */
    _goTripList() {
      this.$router.push('/trip/list')
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.c-tabbar
  @extend .flex-row
  @extend .flex-start
  width 100%
  height 56px
  background-color $color_white
  box-shadow 0px 0.5px 0px 0px $color_black_40 inset
  >.item
    @extend .flex-column
    @extend .flex-center
    flex 1
    >.logo
      width 24px
      height 24px
      background-size 100% 100%
      position relative
      >.badge
        @extend .flex-center
        position absolute
        top -8px
        left 16.5px
        min-width 16px
        height 16px
        padding 1px 2px
        font-size 12px
        border-radius 10px
        border 1px solid $color_white
        background-color $color_theme_200
        color $color_white
        text-align center
    >p
      @extend .hs-font-overline-3
      ellipsis(1)
      font-weight 400
      margin-top 2px
      color $color_black_200
    >.light
      color $color_theme_300
      font-weight 500
</style>
